/**
 * Listing Page JavaScript
 * Handles listing page specific functionality including Google Maps
 */
class ListingPage {
    constructor(options = {}) {
        this.listingData = options.listingData || {};
        this.init();
    }

    init() {
        this.waitForGoogleMaps().then(() => this.initializeMap());
    }

    /**
     * Wait for the Google Maps API to become available.
     * Returns a promise that resolves when ready or rejects after timeout.
     */
    waitForGoogleMaps(retries = 20, interval = 500) {
        return new Promise((resolve, reject) => {
            const check = (remaining) => {
                if (typeof google !== 'undefined' && google.maps && google.maps.LatLng) {
                    resolve();
                } else if (remaining > 0) {
                    setTimeout(() => check(remaining - 1), interval);
                } else {
                    reject(new Error('Google Maps API failed to load'));
                }
            };
            check(retries);
        });
    }

    initializeMap() {
        const mapCanvas = document.getElementById('map-canvas');
        if (!mapCanvas) return;

        if (this.listingData.lat != null && this.listingData.lng != null) {
            this.createMapWithCoordinates(mapCanvas, this.listingData.lat, this.listingData.lng);
        } else if (this.listingData.address) {
            this.geocodeAddress(mapCanvas, this.listingData.address);
        }
    }

    createMapWithCoordinates(mapCanvas, lat, lng) {
        if (typeof google === 'undefined' || !google.maps || !google.maps.LatLng) return;

        const center = new google.maps.LatLng(lat, lng);

        const map = new google.maps.Map(mapCanvas, {
            zoom: 14,
            center: center,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            mapTypeControl: false
        });

        if (this.listingData.radius === 0) {
            new google.maps.Marker({position: center, map: map});
            return;
        }
        const area = new google.maps.Circle({
            strokeColor: '#ff8551',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#ff8551',
            fillOpacity: 0.35,
            map: map,
            center: center,
            radius: this.listingData.radius || 800
        });
        map.fitBounds(area.getBounds());
    }

    geocodeAddress(mapCanvas, address) {
        if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) return;

        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({
            address: address,
            componentRestrictions: { country: 'NZ' }
        }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results[0]) {
                const location = results[0].geometry.location;
                this.createMapWithCoordinates(mapCanvas, location.lat(), location.lng());
            } else {
                this.createDefaultMap(mapCanvas);
            }
        });
    }

    createDefaultMap(mapCanvas) {
        if (typeof google === 'undefined' || !google.maps || !google.maps.LatLng) return;

        new google.maps.Map(mapCanvas, {
            zoom: 5,
            center: new google.maps.LatLng(-40.9006, 174.8860),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            mapTypeControl: false
        });
    }
}

// Function to initialize the listing page (called from Blade template)
window.initializeListingPage = function(listingData) {
    document.addEventListener('DOMContentLoaded', function() {
        new ListingPage({ listingData: listingData });
    });
};
